(() => {
  if (window.AlpineSiegeYearApplications) return;
  window.AlpineSiegeYearApplications = true;

  function init(scope) {
    scope.querySelectorAll('[data-as-year-navigation]').forEach(form => {
      form.dataset.asAutoNavigation = 'true';
      form.querySelector('button[type="submit"]').hidden = true;
    });
    scope.querySelectorAll('[data-as-preorder-boundary]').forEach(boundary => {
      if (boundary.dataset.asReady) return;
      boundary.dataset.asReady = 'true';
      const form = boundary.querySelector('form');
      const button = form.querySelector('[data-as-preorder-submit]');
      const message = form.querySelector('[data-as-preorder-message]');
      const allowedPlans = boundary.dataset.asPlanIds.split(',').filter(Boolean);
      let selectionWasValid = false;
      function valid() {
        const data = new FormData(form);
        const plans = data.getAll('selling_plan');
        const variants = data.getAll('id');
        return boundary.dataset.asRuntimeAllowed === 'true' &&
          form.querySelector('[data-as-nav-ack]')?.checked === true &&
          variants.length === 1 && variants[0] === boundary.dataset.asVariant &&
          plans.length === 1 && allowedPlans.includes(plans[0]);
      }
      function guard() {
        const selectionIsValid = valid();
        // Hand off the initially disabled native button once Dibs supplies an
        // allocated selection. Preserve later app disabled/busy states.
        if (!selectionIsValid && !button.disabled) button.disabled = true;
        else if (selectionIsValid && !selectionWasValid && button.disabled) button.disabled = false;
        selectionWasValid = selectionIsValid;
        // Keep the deposit CTA concise while awaiting acknowledgment too.
        // This only changes its label; the validity and disabled gates above
        // continue to own whether a purchase can proceed.
        const depositAcknowledgmentPending = boundary.dataset.asActiveLabel === 'RESERVE — $99' &&
          boundary.dataset.asRuntimeAllowed === 'true' && button.disabled &&
          form.querySelector('[data-as-nav-ack]')?.checked === false;
        if ((selectionIsValid && !button.disabled) || depositAcknowledgmentPending) {
          const label = button.querySelector('span');
          if (label && label.textContent !== boundary.dataset.asActiveLabel) label.textContent = boundary.dataset.asActiveLabel;
        }
        const copy = selectionIsValid && !button.disabled ? '' : boundary.dataset.asRuntimeAllowed === 'true' ? boundary.dataset.asGateMessage : 'Paid ordering is not open for this application.';
        if (message.textContent !== copy) message.textContent = copy;
      }
      form.addEventListener('submit', event => {
        if (!valid() || button.disabled) {
          event.preventDefault();
          event.stopImmediatePropagation();
          guard();
        }
      }, true);
      form.addEventListener('click', event => {
        if (event.target.closest('[name="add"]') && !valid()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          guard();
        }
      }, true);
      new MutationObserver(guard).observe(form, {subtree:true, childList:true, attributes:true, attributeFilter:['value','disabled','checked']});
      form.addEventListener('change', guard);
      window.addEventListener('pageshow', () => {
        // History can restore form state with or without a BFCache document.
        // Obtain fresh acknowledgements for every displayed application.
        form.querySelectorAll('[data-as-nav-ack]').forEach(input => { input.checked = false; });
        guard();
      });
      guard();
    });
  }
  function navigate(form) {
    const select = form.querySelector('select[name="variant"]');
    if (!select || !select.value || !select.checkValidity()) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', select.value);
    window.location.assign(url.href);
  }
  document.addEventListener('change', event => {
    const form = event.target.closest('[data-as-year-navigation]');
    if (form && event.target.matches('select[name="variant"]')) navigate(form);
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-as-year-navigation]');
    if (!form) return;
    event.preventDefault();
    navigate(form);
  });
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-as-year-navigation] select').forEach(select => {
      const renderedSelection = select.querySelector('option[selected]');
      if (renderedSelection) select.value = renderedSelection.value;
    });
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
})();
